"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatingItem = void 0;
var preact_1 = require("preact");
var floating_item_data_1 = require("./floating-item-data");
var managed_component_1 = require("./managed-component");
var FloatingItem = /** @class */ (function () {
    function FloatingItem(options) {
        var _this = this;
        this._destroyed = false;
        this._isShown = false;
        this._componentRef = null;
        this.remove = function () {
            _this._isShown = false;
            if (!_this._componentRef) {
                return;
            }
            _this._componentRef.update();
        };
        this.add = function () {
            _this._isShown = true;
            if (!_this._componentRef) {
                return;
            }
            _this._componentRef.update();
        };
        this._handleMediaLoaded = function () {
            var kalturaPlayer = _this._options.kalturaPlayer;
            kalturaPlayer.removeEventListener(kalturaPlayer.Event.MEDIA_LOADED, _this._handleMediaLoaded);
            _this.add();
        };
        this._handleFirstPlay = function () {
            var kalturaPlayer = _this._options.kalturaPlayer;
            kalturaPlayer.removeEventListener(kalturaPlayer.Event.FIRST_PLAY, _this._handleFirstPlay);
            _this.add();
        };
        this._options = options;
        this._addPlayerBindings();
    }
    Object.defineProperty(FloatingItem.prototype, "data", {
        get: function () {
            return this._options.data;
        },
        enumerable: false,
        configurable: true
    });
    FloatingItem.prototype.update = function () {
        if (!this._componentRef) {
            return;
        }
        this._componentRef.update();
    };
    /**
     * destory the ui item
     */
    FloatingItem.prototype.destroy = function () {
        this._destroyed = true;
        this.remove();
    };
    FloatingItem.prototype.renderFloatingChild = function (props) {
        var _this = this;
        var label = this._options.data.label;
        return ((0, preact_1.h)(managed_component_1.ManagedComponent, { label: label, renderChildren: function () { return _this._options.data.renderContent(props); }, isShown: function () { return _this._isShown; }, ref: function (ref) { return (_this._componentRef = ref); } }));
    };
    FloatingItem.prototype._addPlayerBindings = function () {
        var _a = this._options, kalturaPlayer = _a.kalturaPlayer, data = _a.data;
        if (data.mode === floating_item_data_1.FloatingUIModes.MediaLoaded) {
            kalturaPlayer.addEventListener(kalturaPlayer.Event.MEDIA_LOADED, this._handleMediaLoaded);
        }
        if (data.mode === floating_item_data_1.FloatingUIModes.FirstPlay) {
            kalturaPlayer.addEventListener(kalturaPlayer.Event.FIRST_PLAY, this._handleFirstPlay);
        }
        if (data.mode === floating_item_data_1.FloatingUIModes.Immediate) {
            this.add();
        }
    };
    return FloatingItem;
}());
exports.FloatingItem = FloatingItem;
//# sourceMappingURL=floating-item.js.map